import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const LiveEventsFeature = ({ active }) => {
   const [visible, setVisible] = useState(false)

   useEffect(() => {
      if (active) {
         setTimeout(() => {
            setVisible(true)
         }, 100)
      } else {
         setVisible(false)
      }
   }, [active])

   return (
      <div className="w-full h-full">
         <div
            className={classNames(
               'absolute top-[15%] left-[15%] w-[70%]'
            )}>
            <div className="flex flex-col gap-4">
               <div
                  className={classNames(
                     'rounded-2xl overflow-hidden border border-solid border-zinc-50/0 shadow-[0px_10px_30px_rgba(0,0,0,0.3)] transition-all duration-700',
                     visible ? '-translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
                  )}>
                  <img
                     className="w-full"
                     src="/assets/custom/communities/images/features/tv/polls.png"
                     alt="TV Live Polls"
                  />
               </div>
               <div
                  className={classNames(
                     'rounded-2xl overflow-hidden border border-solid border-zinc-100/0 shadow-[0px_10px_30px_rgba(0,0,0,0.3)] transition-all duration-700 delay-100',
                     visible ? '-translate-y-0 opacity-40' : 'translate-y-10 opacity-0'
                  )}>
                  <img
                     className="w-full"
                     src="/assets/custom/communities/images/features/tv/feed.png"
                     alt="TV Live Feed"
                  />
               </div>
            </div>
         </div>
      </div>
   )
}

LiveEventsFeature.propTypes = {
   active: PropTypes.bool.isRequired
}

export default LiveEventsFeature
